<template>
<v-dialog v-model="dialog" width="500px" scrollable>
  <v-card>
    <v-simple-table>
      <template v-slot:default>
      <tbody>
        <tr v-for="errs in getHser" :key="errs.errs_nr">
          <td><v-chip :color=kleur()>{{errs.hser_seq}}</v-chip></td>
          <td>{{ errs.errstaal_oms }} <br> {{errs.hser_detail}} </td>
        </tr>
      </tbody>
      </template>
    </v-simple-table>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" small @click="dialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() {
    return {
        dialog: false,
        huis_code: null,
        title: null,
        hser_type: null,
        getHser: {}
    }
  },
  methods: {
    open(title, huis_code, hser_type) {
      this.dialog = true;
      this.title = title;
      this.huis_code = huis_code;
      this.hser_type = hser_type;
      this.$axios
        .post("ares/json/ares/huis/getHser.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHser"
          },
          getHser: {
            huis_code: this.huis_code,
            hser_type: this.hser_type
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.getHser = res.data.getHser;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    kleur(){
      if(this.hser_type == "Error") return 'red'; else return 'orange';
    }
  }
}
</script>
